var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inital)?_c('div',[_c('notifications'),(_vm.user)?_c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_vm._l((_vm.$route.query),function(card,key){return [(_vm.items[key])?_c(key,{key:key,tag:"component",style:({
            zIndex: _vm.priority[key] ? _vm.priority[key] : 10,
          }),attrs:{"id":card}}):_vm._e()]}),_c('router-view')],2):_c('div',[_c('auth')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }